window.receiversTable = null;
var receiversTableOnChangeDisabled = false;
var receiversEdited = [];
var receiversDeleted = [];

var autoAdmitsDeleted = [];

var awayLogTable;
var awayLogTableOnChangeDisabled = false;

var awayLogTableFromPortal;
var awayLogTableFromPortalOnChangeDisabled = false;


var autoAdmitVisitorType = 0;
var autoAdmitVisitorCategory = 0;
var autoAdmitVendorCategory = 1;
var autoAdmitResidentCategory = 4;

var autoAdmitCarType = 1;
var autoAdmitPropertyType = 1;



var autoAdmitTable;
var autoAdmitTableOnChangeDisabled = false;

var autoAdmitOverviewTable;
var autoAdmitOverviewTableOnChangeDisabled = false;

var autoAdmitFromPortalTable;
var autoAdmitFromPortalTableOnChangeDisabled = false;

//var autoAdmitPassesTable;
//var autoAdmitPassesTableOnChangeDisabled = false;



var headsupTable
var headsupTableOnChangeDisabled = false;

var broadcastTable
var broadcastTableOnChangeDisabled = false;

var unitsAlreadyInAwayLog = [];

function notificationByOptionsFromNumber(notifyBy) {

    var ret = "";
    if (notifyBy == 3) {
        ret = "Email;Text";
    }
    else if (notifyBy == 2) {
        ret = "Email";
    }
    else if (notifyBy == 1) {
        ret = "Text";
    }
    return ret;
}

function notificationWhenOptionsFromNumber(notifyWhen) {


    var arr = [];

    var ret = "";

    if ((notifyWhen & 1) > 0) {
        arr.push("Visitor");
    }
    if ((notifyWhen & 2) > 0) {
        arr.push("Vendor");
    }
    if ((notifyWhen & 4) > 0) {
        arr.push("Auto-Admit visitor");
    }
    if ((notifyWhen & 8) > 0) {
        arr.push("Parcel");
    }
    if ((notifyWhen & 16) > 0) {
        arr.push("Visitor turned away");
    }





    if (arr.length > 0) {
        ret = arr.join(";");
    }

    //console.log("parsed notifyWhen : " + notifyWhen + " to : " + ret);
    // console.log(ret);

    return ret;
}

function broadcastExemptFromNumber(setting) {

    var ret = "";
    if (setting == 3) {
        ret = "Both";
    }
    else if (setting == 2) {
        ret = "Emails";
    }
    else if (setting == 1) {
        ret = "Texts";
    }
    return ret;
}




function CreatePeopleTables(residentTerm, dateFormat) {

    residentTerm = capitalizeFirstLetterPeoplesPage(residentTerm);

    var tableHeight = window.innerHeight - 128 - 256

    if (tableHeight < 256) {
        tableHeight = 256;
    }

    var showIndex = false;

    var menuWidth = 250;

    var pageMarginAndPaddingTotal = 100;

    if (window.location.href.indexOf("screen/people") > -1) {
        pageMarginAndPaddingTotal = 64;
        menuWidth = 0;

        tableHeight = window.innerHeight - 300 - 48;
    }

    var tableWidth = window.innerWidth - menuWidth - pageMarginAndPaddingTotal;

    window.addEventListener('resize', function (event) {

        if (window.location.href.indexOf("screen/people") > -1) {
            pageMarginAndPaddingTotal = 0;
            menuWidth = 0;

            if (tableHeight < 256) {
                tableHeight = 256;
            }

            var newHeight = window.innerHeight - 300 - 48;
            console.log("window.innerHeight is " + window.innerHeight);
            //$('#receivers .jexcel_content').css({ "maxHeight": newHeight + "px" });
            //$('#awayloggrid .jexcel_content').css({ "maxHeight": newHeight + "px" });
            //$('#awayloggridportal .jexcel_content').css({ "maxHeight": newHeight + "px" });

            //$('#autoadmitgridoverview .jexcel_content').css({ "maxHeight": newHeight + "px" });
            //$('#autoadmitgrid .jexcel_content').css({ "maxHeight": newHeight / 3 + "px" });
            //$('#autoadmitgridfromportal .jexcel_content').css({ "maxHeight": newHeight / 3 + "px" });



        }

        var newWidth = window.innerWidth - menuWidth - pageMarginAndPaddingTotal;
        $('#receivers .jexcel_content').width(newWidth);
        $('#awayloggrid .jexcel_content').width(newWidth);
        $('#awayloggridportal .jexcel_content').width(newWidth);

        $('#autoadmitgridoverview .jexcel_content').width(newWidth);
        $('#autoadmitgrid .jexcel_content').width(newWidth);
        $('#autoadmitgridfromportal .jexcel_content').width(newWidth);
    }, true);

    
    window.receiversTable = jexcel(document.getElementById('receivers'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        allowInsertRow: false,
        allowManualInsertRow: false,
        allowManualDeleteRow: true,
       //allowDeleteRow: false,
        
        columnDrag: false,
        data: null,
        pagination: 100,
        tableWidth: tableWidth + 'px',
        tableHeight: tableHeight + 'px',
        minDimensions: [2, 0],
        search: true,
        columnSorting: false,
        tableOverflow: true,
        columns: [
            {
                title: 'ReceiverId',
                type: 'hidden',
                width: '20px',
            },
            {
                title: 'Edited',
                type: 'hidden',
                width: '20px',
            },
            {
                title: 'Unit',
                type: 'text',
                width: '200px',
                readOnly: true
            },
            {
                title: 'Unit Group',
                type: 'text',
                width: '140px',
                readOnly: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
                readOnly: true
            },
            {
                title: 'Name',
                type: 'string',
                width: '240px',
                readOnly: true
            },
            {
                title: 'Cell Phone',
                type: 'text',
                width: '140px',
                readOnly: true
            },
            {
                title: 'Home Phone',
                type: 'text',
                width: '140px',
                readOnly: true
            },
            {
                title: 'Email',
                type: 'text',
                width: '140px',
                readOnly: true
            },
            {
                title: 'Comment',
                type: 'text',
                width: '140px',
                wordWrap: true,
                readOnly: true
            },
            {
                title: 'Member #',
                type: 'text',
                width: '80px',
                readOnly: true
            },
            {
                title: 'Rented',
                type: 'checkbox',
                width: '60px',
                readOnly: true
            },
            {
                title: 'Req. Call',
                type: 'checkbox',
                width: '70px',
                readOnly: true
            },
            {
                title: ' ',
                type: 'html',
                width: '160px',
                wordWrap: true
            },
            //{
            //    type: 'dropdown',
            //    width: '150',
            //    source: ['Email', 'Text'],
            //    title: 'Auto notification opt',
            //    multiple: true
            //},
            //{
            //    type: 'dropdown',
            //    width: '160',
            //    source: ['Visitor', 'Vendor', 'Auto-Admit visitor', 'Parcel', 'Visitor turned away'],
            //    title: 'Auto notification event',
            //    multiple: true
            //}
        ],
        //toolbar: [
        //    {
        //        type: 'text',
        //        content: 'New Resident',
        //        width: '122px',
        //        onclick: function () {
        //        }
        //    }],
        onload: function (instance) {

         
            //$($(instance).find('table')).each(function (i, obj) {
            //    $(obj).addClass('jexcel_hidden_index');
            //});
            

            //console.log(instance);

            //if (!showIndex) {
            //    $($(instance).find('table')).each(function (i, obj) {
            //        $(obj).addClass('jexcel_hidden_index');
            //    });
            //}


            $($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                var residentUnitValue = $(obj).text();

                if (residentUnitValue != null && residentUnitValue.length > 0 && i > 0) {

                    // $(obj).css("color", "#ccc");
                    // $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="3"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="4"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td')).each(function (i, obj) {
                $(obj).css("background-color", "#f8f8f8");
                $(obj).css("color", "#333");
            });


            $($(instance).find('td[data-x="13"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f0f0f0");
            });




            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#people-residents-header-checkin-title"));
            });
            $(".jexcel_search").css({ "border": "1px solid #ccc" });
            $(".jexcel_search").css({ "margin-top": "20px" });


        },
        onbeforechange: function (instance, cell, x, y, value) {
           
            if (!receiversTableOnChangeDisabled) {
                receiversTableOnChangeDisabled = true;
                console.log("set edit for x, y = " + x + ", " + y);
                window.receiversTable.setValueFromCoords(1, y, 'true', true);
                receiversTableOnChangeDisabled = false;
            }

            receiversEdited.push(y);
            
        },
        onbeforedeleterow: function (instance, y, numOfRows) {
            console.log("set delete for x, y = " + y + " and forward " + numOfRows);
            var idsStr = "";
            for (var i = 0; i < numOfRows; i++) {
                try {
                    var deletedReceiverId = parseInt(window.receiversTable.getRowData(y + i)[0]);
                    if (!isNaN(deletedReceiverId)) {
                        console.log("Deleted: " + deletedReceiverId);
                        receiversDeleted.push(deletedReceiverId);
                        idsStr = idsStr + deletedReceiverId + ",";
                    }
                   
                }
                catch (e) {

                }
            }

            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartDeleteReceiver', idsStr);



            

        },
        oneditionstart: function (instance, cell, x, y) {
        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

            //Used to jump to next column while marking the columnSeperator
            if (x1 == 4) {
                window.receiversTable.updateSelectionFromCoords(5, y1, 5, y2);
                console.log("selected" + x1 + y1 + x2 + y2);
            }
        },
        onbeforeinsertrow: function (obj, cel, val) {
            alert("inserted row!");
        },
        onchange: function (obj, cel, val) { },
        rowResize: true
    });
    
    console.log("recv table created");


    var receiverUnits = [];
    var receiverNames = [];

    var receiversInCacheCount = receiversCache.length;
    for (var i = 0; i < receiversInCacheCount; i++) {

        var rowValue = receiversCache[i]['receiverUnit'];
        if (isEmptyOrSpaces(rowValue) == false) {
            receiverUnits.push(rowValue);
        }

        rowValue = receiversCache[i]['receiverName'];
        if (isEmptyOrSpaces(rowValue) == false) {
            receiverNames.push(rowValue);
        }
    }

    awayLogResidentDropdownFilter = function (instance, cell, c, r, source) {


        var allReceivers = receiverUnits;
        var allReceiversCount = allReceivers.length;

        var receiversInTableAll = awayLogTable.getColumnData(0);
        var receiversInTable = [];

        var receiversToDisplay = [];


        var rowCount = 100;
        if (receiversInTableAll != null) {
            rowCount = receiversInTableAll.length;
        }

        var receiversInTableCount = 0;
        for (var ix = 0; ix < rowCount; ix++) {
            if (receiversInTableAll[ix] != null && receiversInTableAll[ix] != "") {
                receiversInTable.push(receiversInTableAll[ix]);
                receiversInTableCount++;
            }
        }

        for (var jx = 0; jx < allReceiversCount; jx++) {
            var receiverAlreadyInTable = false;

            for (var kx = 0; kx < receiversInTableCount; kx++) {

                if (allReceivers[jx] != null && allReceivers[jx] != "") {
                    try {
                        if (allReceivers[jx].toLowerCase().trim() == receiversInTable[kx].toLowerCase().trim()) {
                            receiverAlreadyInTable = true;
                            break;
                        }
                    } catch (e) {

                    }
                }


            }

            if (receiverAlreadyInTable == false) {
                receiversToDisplay.push(allReceivers[jx]);
            }
        }


        return receiversToDisplay;

    }




    awayLogTable = jexcel(document.getElementById('awayloggrid'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        tableHeight: tableHeight/2 + 'px',
        tableWidth: tableWidth + 'px',
        search: true,
        minDimensions: [2, 100],
        tableOverflow: true,
        columns: [
            {
                title: 'AwayLogId',
                type: 'hidden',
                width: '200px',
            },
            {
                title: residentTerm + ' Unit',
                type: 'dropdown',
                source: receiverUnits,
                width: '220px',
                filter: awayLogResidentDropdownFilter
            },
            {
                title: residentTerm + ' Name',
                type: 'string',
                width: '200px',
                readOnly: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Away',
                type: 'checkbox',
                width: '80px',
            },
            {
                title: 'Away from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },
            {
                title: 'Away to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Holds',
                type: 'checkbox',
                width: '80px',
            },
            {
                title: 'Holds content',
                type: 'dropdown',
                source: ['Mail', 'Parcels', 'Newspapers', 'Water delivery', 'Other (specify in Other)'],
                width: '150px',
                multiple: true,
                wordWrap: true
            },
            {
                title: 'Holds from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },
            {
                title: 'Holds to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },

            {
                title: 'Other',
                type: 'text',
                width: '150px',
                wordWrap: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Comment',
                type: 'text',
                width: '150px',
                wordWrap: true
            }
            //,
            //{
            //    title: 'Desc.',
            //    type: 'text',
            //    width: '75px',
            //    wordWrap: true
            //}
        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors
            $($(instance).find('td[data-x="3"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="13"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });


            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#people-awaylog-header-checkin-title"));
            });
            $(".jexcel_search").css({ "border": "1px solid #ccc" });



            $($(instance).find('.jexcel_content')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css({
                        "border-color": "#f0f0f0",
                        "border-width": "1px",
                        "border-style": "solid"
                    });
                }
            });
 
           


        },
        onchange: function (obj, cel, val) {
            // Used to avoid onchange event to propagate
            if (awayLogTableOnChangeDisabled) {
                return;
            }

            var checkinId = 0;
            var newValue = "";
            var columnToUpdate = "";



            //Grid coordinates of data just updated
            var x = parseInt($(cel).attr("data-x"));
            var y = parseInt($(cel).attr("data-y"));

            //We changed something in the first row / check in row

            //Check if the column we changed belongs to the Receiver data information
            if (x == 1) {
                //Get the ID of Receiver data changed

                var receiverLookedUp = null;
                //Get the string value of the data we just changed
                var dataChangedValue = awayLogTable.getRowData(y)[1];

                //Search through receivers that has a property with that data value
                for (var i = 0; i < receiversCache.length; i++) {
                    if (receiversCache[i]['receiverUnit'] == dataChangedValue) {
                        receiverLookedUp = receiversCache[i];
                    }
                }

                //If we didnt find any receiver with corresponding data, return
                if (receiverLookedUp == null) {
                    return;
                }

                lastReceiverLookedUpCache = receiverLookedUp;

                var columnX = 2;

                // Dont propagate onchange events
                awayLogTableOnChangeDisabled = true;

                // Fetch data from looked up receiver
                var columnValue = receiverLookedUp['receiverName'];

                // Set internal value
                awayLogTable.setValueFromCoords(columnX, y, columnValue, true);

                $($('#awayloggrid').find('td[data-x="2"][data-y="' + y + '"]')).each(function (i, obj) {
                    //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                    if (i == y) {
                        $(obj).html(columnValue);
                    }
                });

                awayLogTableOnChangeDisabled = false;


            }



        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

            //Used to jump to next column while marking the columnSeperator
            if (x1 == 3 || x1 == 7 || x1 == 13) {
                awayLogTable.updateSelectionFromCoords(x1 + 1, y1, x2 + 1, y2);
                console.log("selected" + x1 + y1 + x2 + y2);
            }
        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
    });


    awayLogTableFromPortal = jexcel(document.getElementById('awayloggridportal'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        tableHeight: tableHeight / 2 + 'px',
        tableWidth: tableWidth + 'px',
        search: true,
        minDimensions: [2, 100],
        tableOverflow: true,
        columns: [
            {
                title: 'AwayLogId',
                type: 'hidden',
                width: '200px',
            },
            {
                title: residentTerm + ' Unit',
                type: 'dropdown',
                source: receiverUnits,
                width: '220px',
                filter: awayLogResidentDropdownFilter
            },
            {
                title: residentTerm + ' Name',
                type: 'string',
                width: '200px',
                readOnly: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Away',
                type: 'checkbox',
                width: '80px',
            },
            {
                title: 'Away from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },
            {
                title: 'Away to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Holds',
                type: 'checkbox',
                width: '80px',
            },
            {
                title: 'Holds content',
                type: 'dropdown',
                source: ['Mail', 'Parcels', 'Newspapers', 'Water delivery', 'Other (specify in Other)'],
                width: '150px',
                multiple: true,
                wordWrap: true
            },
            {
                title: 'Holds from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },
            {
                title: 'Holds to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '120px',
            },

            {
                title: 'Other',
                type: 'text',
                width: '150px',
                wordWrap: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Comment',
                type: 'text',
                width: '75px',
                wordWrap: true
            },
            {
                title: 'Desc.',
                type: 'text',
                width: '75px',
                wordWrap: true
            }
        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors
            $($(instance).find('td[data-x="3"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="13"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });


            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#people-awaylogportal-header-checkin-title"));
            });
            $(".jexcel_search").css({ "border": "1px solid #ccc" });



            $($(instance).find('.jexcel_content')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css({
                        "border-color": "#f0f0f0",
                        "border-width": "1px",
                        "border-style": "solid"
                    });
                }
            });

        },
        onchange: function (obj, cel, val) {
            // Used to avoid onchange event to propagate
            if (awayLogTableFromPortalOnChangeDisabled) {
                return;
            }

            var checkinId = 0;
            var newValue = "";
            var columnToUpdate = "";


          
            //Grid coordinates of data just updated
            var x = parseInt($(cel).attr("data-x"));
            var y = parseInt($(cel).attr("data-y"));

            //We changed something in the first row / check in row

            //Check if the column we changed belongs to the Receiver data information
            if (x == 1) {
                //Get the ID of Receiver data changed

               

                var receiverLookedUp = null;
                //Get the string value of the data we just changed
                var dataChangedValue = awayLogTableFromPortal.getRowData(y)[1];

                //Search through receivers that has a property with that data value
                for (var i = 0; i < receiversCache.length; i++) {
                    if (receiversCache[i]['receiverUnit'] == dataChangedValue) {
                        receiverLookedUp = receiversCache[i];
                    }
                }

                //If we didnt find any receiver with corresponding data, return
                if (receiverLookedUp == null) {
                    return;
                }

                lastReceiverLookedUpCache = receiverLookedUp;

                var columnX = 2;

                // Dont propagate onchange events
                awayLogTableFromPortalOnChangeDisabled = true;

                // Fetch data from looked up receiver
                var columnValue = receiverLookedUp['receiverName'];

                // Set internal value
                awayLogTableFromPortal.setValueFromCoords(columnX, y, columnValue, true);

                $($('#awayloggridportal').find('td[data-x="2"][data-y="' + y + '"]')).each(function (i, obj) {
                    //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                    if (i == y) {
                        $(obj).html(columnValue);
                    }
                });

                awayLogTableFromPortalOnChangeDisabled = false;


            }



        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

            //Used to jump to next column while marking the columnSeperator
            if (x1 == 3 || x1 == 7 || x1 == 13) {
                awayLogTableFromPortal.updateSelectionFromCoords(x1 + 1, y1, x2 + 1, y2);
                console.log("selected" + x1 + y1 + x2 + y2);
            }
        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
    });

    autoAdmitOverviewTable = jexcel(document.getElementById('autoadmitgridoverview'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        allowInsertRow: false,
        allowManualInsertRow: false,
        allowDeleteRow: false,
        selectionCopy: false,
        columnDrag: false,
        data: null,
        pagination: 100,
        tableWidth: tableWidth + 'px',
        tableHeight: tableHeight + 'px',
        minDimensions: [2, 100],
        wordWrap: true,
        search: true,
        tableOverflow: true,
        columns: [
            {
                title: residentTerm + ' Unit',
                type: 'text',
                width: '250px',
                readOnly: true
            },
            {
                title: residentTerm + ' Name',
                type: 'text',
                width: '200px',
                readOnly: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
                readOnly: true
            },
            {
                title: ' ',
                type: 'text',
                width: '200px',
                readOnly: true
            },
            {
                title: ' ',
                type: 'text',
                width: '200px',
                readOnly: true
            },
            //{
            //    title: 'Property Access',
            //    type: 'html',
            //    width: '200px',
            //    readOnly: true
            //},
            {
                title: 'Vehicle Access',
                type: 'html',
                width: '200px',
                readOnly: true
            },
            {
                title: 'Auto-Admit Access',
                type: 'html',
                readOnly: true,
                width: '200px'
            },
        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors

            $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="5"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f0f0f0");
            });

            $($(instance).find('td[data-x="6"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f0f0f0");
            });

            $($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f0f0f0");
            });


            $($(instance).find('td')).each(function (i, obj) {
                $(obj).css("background-color", "#f8f8f8");
                $(obj).css("color", "#333");
            });


            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#people-autoadmit-header-checkin-title"));
            });

            $(".jexcel_search").css({ "border": "1px solid #ccc" });


            try {

                //$($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                //    if (i == 0) {
                //        $(obj).html('<i class="fas fa-id-card text-info" style="font-size:100%;padding-right:5px;"></i><span>' + 'Property Access' + '</span>');
                //    }
                //});

                $($(instance).find('td[data-x="6"]')).each(function (i, obj) {
                    if (i == 0) {
                        $(obj).html('<i class="fas fa-car text-info" style="font-size:100%;padding-right:5px;"></i><span>' + 'Vehicle Access' + '</span>');
                    }
                });

                $($(instance).find('td[data-x="5"]')).each(function (i, obj) {
                    if (i == 0) {
                        $(obj).html('<i class="fas fa-user-tie text-info" style="font-size:100%;padding-right:5px;"></i><span>' + 'Auto-Admit Access' + '</span>');
                    }
                });
                
            } catch (e) {
                console.log(e);
            }


        },
        onchange: function (obj, cel, val) {
            // Used to avoid onchange event to propagate
            if (autoAdmitTableOnChangeDisabled) {
                return;
            }

            var checkinId = 0;
            var newValue = "";
            var columnToUpdate = "";

            //Grid coordinates of data just updated
            var x = parseInt($(cel).attr("data-x"));
            var y = parseInt($(cel).attr("data-y"));


        },
        onselection: function (instance, x1, y1, x2, y2, origin) {


          
               
            autoAdmitOverviewTable.resetSelection(false);

            ////Used to jump to next column while marking the columnSeperator
            //if (x1 == 2) {
            //    autoAdmitOverviewTable.updateSelectionFromCoords(x1 + 1, y1, x2 + 1, y2);
            //    console.log("selected" + x1 + y1 + x2 + y2);
            //}

            /*
            var t = autoAdmitOverviewTable.getSelectedColumns(true);
            var buttonColumnIndex = 6;
            
            //Stop the selection if user selects checkin timestamp or checkout button cols
            if (t != null && (t.indexOf(buttonColumnIndex) >= 0 && t.indexOf(1) == -1)) {

               // autoAdmitOverviewTable.resetSelection(false);
            }*/

            var t = autoAdmitOverviewTable.getSelectedColumns(true);
            var buttonColumnIndex = 7;
            var buttonColumnIndex2 = 6;
            var buttonColumnIndex3 = 5;

            //Stop the selection if user selects checkin timestamp or checkout button cols
            if (t != null && ((t.indexOf(buttonColumnIndex) >= 0 || t.indexOf(buttonColumnIndex2) >= 0 || t.indexOf(buttonColumnIndex3) >= 0) && t.indexOf(1) == -1)) {

                

                $($(instance).find('td[data-x="5"]')).each(function (i, obj) {


                    $(obj).removeClass("highlight-selected");

                    $(obj).removeClass("highlight-top");
                    $(obj).removeClass("highlight-right");
                    $(obj).removeClass("highlight-bottom");
                    $(obj).removeClass("highlight-left");

                    $(obj).removeClass("selected");

                    $(obj).parent().removeClass("jexcel_corner");
                    $(obj).parent().parent().removeClass("jexcel_corner");
                    $(obj).parent().parent().parent().removeClass("jexcel_corner");
                    $(obj).parent().parent().parent().parent().removeClass("jexcel_corner");
                    $(obj).parent().parent().parent().parent().parent().removeClass("jexcel_corner");

                    //$('.jexcel_corner').css({ display: 'none' });
                    //$(".jexcel_corner").css("display", "none");
                    //setTimeout(function () {
                    //    $(".jexcel_corner").css("display", "block");
                    //}, 3000);
                    


                    $(obj).removeClass("highlight");
                });

                $($(instance).find('td[data-x="6"]')).each(function (i, obj) {


                    $(obj).removeClass("highlight-selected");

                    $(obj).removeClass("highlight-top");
                    $(obj).removeClass("highlight-right");
                    $(obj).removeClass("highlight-bottom");
                    $(obj).removeClass("highlight-left");

                    $(obj).removeClass("selected");

                    $(obj).removeClass("highlight");
                });
              

                $($(instance).find('td[data-x="7"]')).each(function (i, obj) {


                    $(obj).removeClass("highlight-selected");

                    $(obj).removeClass("highlight-top");
                    $(obj).removeClass("highlight-right");
                    $(obj).removeClass("highlight-bottom");
                    $(obj).removeClass("highlight-left");

                    $(obj).removeClass("selected");

                    $(obj).removeClass("highlight");
                });

            }

        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
    });

    residentNameDropdown = async function (instance, cell, c, r, source) {
        var personsNameList = ['', ''];

        var unit = '';

        var allPersonsForUnitPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'GetAllPersonsForUnitFromGrid', unit)
            .then(r => {
                return r;
            });

        personsNameList = await allPersonsForUnitPromise;

        try {
            personsNameList = personsNameList.sort();
        } catch (e) {
        }

        return personsNameList;
    }

    screenNameDropdown = async function (instance, cell, c, r, source) {
        var screenNameList = ['', ''];

        var unit = '';

        var allScreensPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'GetAllScreenNamesFromGrid', unit)
            .then(r => {
                return r;
            });

        screenNameList = await allScreensPromise;

        //try {
        //    personsNameList = personsNameList.sort();
        //} catch (e) {
        //}

        return screenNameList;
    }

    //transponderDropdown = async function (instance, cell, c, r, source) {
    //    var transponderList = ['', ''];

    //    var unit = '';

    //    var allScreensPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'GetAllTransponderNumbersForCurrentUnitFromGrid', unit)
    //        .then(r => {
    //            return r;
    //        });

    //    transponderList = await allScreensPromise;

    //    try {
    //        transponderList = transponderList.sort();
    //    } catch (e) {
    //    }

    //    return transponderList;
    //}


    autoAdmitTable = jexcel(document.getElementById('autoadmitgrid'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteRow: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        allowInsertRow: false,
        allowManualInsertRow: false,
        columnDrag: false,
        data: null,
        tableWidth: tableWidth + 'px',
        tableHeight: tableHeight / 3 + 'px',
        minDimensions: [2, 100],
        wordWrap: false,
        allowExport: false,
        search: true,
        tableOverflow: true,
        columns: [
            {
                title: 'AdmitId',
                type: 'hidden',
                width: '200px',
            },
            {
                title: 'Name *',
                type: 'text',
                width: '250px',
            },
            {
                title: 'Plate',
                type: 'text',
                width: '100px',
            },
            {
                title: 'Category',
                type: 'dropdown',
                source: ['Visitor', 'Vendor', 'Resident'],
                width: '100px',
                multiple: false
            },
            {
                title: 'Driver License #',
                type: 'text',
                width: '120px'
            },
            {
                title: 'Identification',
                type: 'text',
                width: '150px'
            },
            {
                title: 'Phone',
                type: 'text',
                width: '150px'
            },
            {
                title: 'Representative',
                type: 'text',
                width: '120px'
            },
            {
                title: 'Relationship to resident',
                type: 'text',
                width: '200px',
            },
            {
                title: 'Visit Resident',
                type: 'dropdown',
                source: ['', ''],
                filter: residentNameDropdown,
                width: '250px',
                multiple: false
            },
            {
                title: 'Entrance',
                type: 'dropdown',
                source: ['', ''],
                readOnly: true,
                filter: screenNameDropdown,
                width: '250px',
                multiple: true
            },
            {
                title: 'Transponder/Tag #',
                type: 'text',
                readOnly: true,
                width: '200px'
            },
            {
                title: 'Duration',
                type: 'dropdown',
                source: ['Temporary', 'Permanent'],
                width: '100px',
                multiple: false
            },
            {
                title: 'Entry from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '100px',
            },
            {
                title: 'Entry to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '100px',
            },
            {
                title: 'Description',
                type: 'text',
                width: '200px',
            },
            {
                title: 'Access',
                type: 'dropdown',
                source: ['Allow', 'Banned'],
                width: '100px',
                multiple: false
            },
            {
                title: 'Comment',
                type: 'text',
                width: '100px',
                wordWrap: true
            },
            {
                title: 'Added',
                type: 'text',
                width: '200px',
                readOnly: true
            },
            {
                title: 'Pass',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
            {
                title: ' ',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
            {
                title: ' ',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
            {
                title: ' ',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
            {
                title: ' ',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors

            //$($(instance).find('td[data-x="2"]')).each(function (i, obj) {
            //    $(obj).css("background-color", "#ccc");
            //});

            //$($(instance).find('td[data-x="0"]')).each(function (i, obj) {
            //    if (i == 0) {
            //        $(obj).css("font-weight", "bold");
            //    }
            //});

            //$($(instance).find('td[data-x="1"]')).each(function (i, obj) {
            //    if (i == 0) {
            //        $(obj).css("font-weight", "bold");
            //    }
            //});

            //Middle Mouse Horizontal Scroll Bugfix
            setTimeout(function () {
                try {
                    autoAdmitTable.updateSelectionFromCoords(0, 0, 0, 0);
                }
                catch { }
            }, 3000);

            

            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#people-autoadmitdetails-header-checkin-title"));
            });


            $($(instance).find('.jexcel_content')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css({
                        "border-color": "#f0f0f0",
                        "border-width": "1px",
                        "border-style": "solid"
                    });
                }
            });

            $(".jexcel_search").css({ "border": "1px solid #ccc" });
        },
        onchange: function (obj, cel, val) {
            // Used to avoid onchange event to propagate
            //if (autoAdmitTableOnChangeDisabled) {
            //    return;
            //}

            //var checkinId = 0;
            //var newValue = "";
            //var columnToUpdate = "";



            ////Grid coordinates of data just updated
            var x = parseInt($(cel).attr("data-x"));
            var y = parseInt($(cel).attr("data-y"));

            //We changed something in the first row / check in row

           
            console.log("Changed, x=" + x + ",y=" + y);


        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
        onbeforedeleterow: function (instance, y, numOfRows) {
            //var idsStr = "";
            //for (var i = 0; i < numOfRows; i++) {
            //    try {
            //        var deletedAutoAdmitId = parseInt(window.autoAdmitTable.getRowData(y + i)[0]);
            //        if (!isNaN(deletedAutoAdmitId)) {
            //            idsStr = idsStr + deletedAutoAdmitId + ",";
            //        }
                    
            //    }
            //    catch (e) {

            //    }
            //}
            //idsStr += "0";


            //DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartDeleteAutoAdmit', idsStr);
        },
    });

   

    autoAdmitFromPortalTable = jexcel(document.getElementById('autoadmitgridfromportal'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowDeleteRow: false,
        allowRenameColumn: false,
        allowInsertRow: false,
        allowManualInsertRow: false,
        columnDrag: false,
        data: null,
        allowExport: false,
        tableWidth: tableWidth + 'px',
        tableHeight: tableHeight / 3 + 'px',
        minDimensions: [2, 100],
        wordWrap: false,
        search: true,
        tableOverflow: true,
        columns: [
            {
                title: 'AdmitId',
                type: 'hidden',
                width: '200px',
            },
            {
                title: 'Name *',
                type: 'text',
                width: '250px',
            },
            {
                title: 'Plate',
                type: 'text',
                width: '100px',
            },
            {
                title: 'Category',
                type: 'dropdown',
                source: ['Visitor', 'Vendor', 'Resident'],
                width: '100px',
                multiple: false
            },
            {
                title: 'Driver License #',
                type: 'text',
                width: '120px'
            },
            {
                title: 'Identification',
                type: 'text',
                width: '150px'
            },
            {
                title: 'Phone',
                type: 'text',
                width: '150px'
            },
            {
                title: 'Representative',
                type: 'text',
                width: '120px'
            },
            {
                title: 'Relationship to resident',
                type: 'text',
                width: '200px',
            },
            {
                title: 'Visit Resident',
                type: 'dropdown',
                source: [],
                width: '250px',
                filter: residentNameDropdown,
                multiple: false
            },
            {
                title: 'Entrance',
                type: 'dropdown',
                source: ['', ''],
                filter: screenNameDropdown,
                width: '250px',
                multiple: true
            },
            {
                title: 'Transponder/Tag #',
                type: 'text',
                readOnly: true,
                width: '200px'
            },
            {
                title: 'Duration',
                type: 'dropdown',
                source: ['Temporary', 'Permanent'],
                width: '100px',
                multiple: false
            },
            {
                title: 'Entry from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '100px',
            },
            {
                title: 'Entry to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' },
                width: '100px',
            },
            {
                title: 'Description',
                type: 'text',
                width: '200px',
            },
            {
                title: 'Access',
                type: 'dropdown',
                source: ['Allow', 'Banned'],
                width: '100px',
                multiple: false
            },
            {
                title: 'Comment',
                type: 'text',
                width: '100px',
                wordWrap: true
            },
            {
                title: 'Added',
                type: 'text',
                readOnly: true,
                width: '200px'
            },
            {
                title: 'Pass',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
            {
                title: ' ',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
            {
                title: ' ',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
            {
                title: ' ',
                type: 'html',
                readOnly: true,
                width: '100px'
            },
        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors

            //$($(instance).find('td[data-x="2"]')).each(function (i, obj) {
            //    $(obj).css("background-color", "#ccc");
            //});

            //$($(instance).find('td[data-x="0"]')).each(function (i, obj) {
            //    if (i == 0) {
            //        $(obj).css("font-weight", "bold");
            //    }
            //});

            //$($(instance).find('td[data-x="1"]')).each(function (i, obj) {
            //    if (i == 0) {
            //        $(obj).css("font-weight", "bold");
            //    }
            //});


            //Middle Mouse Horizontal Scroll Bugfix
            setTimeout(function () {
                try {
                    autoAdmitFromPortalTable.updateSelectionFromCoords(0, 0, 0, 0);
                }
                catch { }
            }, 3000);

            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#people-autoadmitaddedbyuser-header-checkin-title"));
            });


         

            $(".jexcel_search").css({ "border": "1px solid #ccc" });

            $($(instance).find('.jexcel_content')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css({
                        "border-color": "#f0f0f0",
                        "border-width": "1px",
                        "border-style": "solid"
                    });
                }
            });
        },
        onchange: function (obj, cel, val) {
            // Used to avoid onchange event to propagate
            if (autoAdmitTableOnChangeDisabled) {
                return;
            }

            var checkinId = 0;
            var newValue = "";
            var columnToUpdate = "";



            //Grid coordinates of data just updated
            var x = parseInt($(cel).attr("data-x"));
            var y = parseInt($(cel).attr("data-y"));

            //We changed something in the first row / check in row

           
        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

            //Used to jump to next column while marking the columnSeperator
            //if (x1 == 2) {
            //    autoAdmitFromPortalTable.updateSelectionFromCoords(x1 + 1, y1, x2 + 1, y2);
            //    console.log("selected" + x1 + y1 + x2 + y2);
            //}
        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
        onbeforedeleterow: function (instance, y, numOfRows) {
            //var idsStr = "";
            //for (var i = 0; i < numOfRows; i++) {
            //    try {
            //        var deletedAutoAdmitId = parseInt(window.autoAdmitFromPortalTable.getRowData(y + i)[0]);
            //        if (!isNaN(deletedAutoAdmitId)) {
            //            idsStr = idsStr + deletedAutoAdmitId + ",";
            //        }
                    
            //    }
            //    catch (e) {

            //    }
            //}
            //idsStr += "0";

            //DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartDeleteAutoAdmit', idsStr);
        },
    });
    


    headsupTable = jexcel(document.getElementById('headsupgrid'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        tableWidth: tableWidth + 'px',
        tableHeight: tableHeight + 'px',
        minDimensions: [2, 100],
        wordWrap: true,
        search: true,
        tableOverflow: true,
        columns: [
            {
                title: residentTerm + ' Unit',
                type: 'dropdown',
                source: receiverUnits,
                width: '250px',
            },
            {
                title: residentTerm + ' Name',
                type: 'text',
                width: '200px',
                readOnly: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Active from',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY HH24:MI' : 'MM/DD/YYYY HH24:MI', time: 1 },
                width: '150px',
            },
            {
                title: 'Active to',
                type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY HH24:MI' : 'MM/DD/YYYY HH24:MI', time: 1 },
                width: '150px',
            },
            {
                title: 'Check in alert',
                type: 'checkbox',
                width: '100px',
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Note',
                type: 'text',
                width: '500px',
                wordWrap: true
            }
            //,
            //{
            //    title: 'Duration',
            //    type: 'dropdown',
            //    source: ['Temporary', 'Permanent'],
            //    width: '150px',
            //    multiple: false
            //},

        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors

            $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="6"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            $($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                $(obj).prepend($("#people-eventlist-header-checkin-title"));
            });

            $(".jexcel_search").css({ "border": "1px solid #ccc" });

        },
        onchange: function (obj, cel, val) {
            // Used to avoid onchange event to propagate
            if (headsupTableOnChangeDisabled) {
                return;
            }

            var checkinId = 0;
            var newValue = "";
            var columnToUpdate = "";



            //Grid coordinates of data just updated
            var x = parseInt($(cel).attr("data-x"));
            var y = parseInt($(cel).attr("data-y"));

            //We changed something in the first row / check in row

            //Check if the column we changed belongs to the Receiver data information
            if (x == 0) {
                //Get the ID of Receiver data changed

                var receiverLookedUp = null;
                //Get the string value of the data we just changed
                var dataChangedValue = headsupTable.getRowData(y)[0];

                //Search through receivers that has a property with that data value
                for (var i = 0; i < receiversCache.length; i++) {
                    if (receiversCache[i]['receiverUnit'] == dataChangedValue) {
                        receiverLookedUp = receiversCache[i];
                    }
                }

                //If we didnt find any receiver with corresponding data, return
                if (receiverLookedUp == null) {
                    return;
                }

                lastReceiverLookedUpCache = receiverLookedUp;

                var columnX = 1;

                // Dont propagate onchange events
                headsupTableOnChangeDisabled = true;

                // Fetch data from looked up receiver
                var columnValue = receiverLookedUp['receiverName'];

                // Set internal value
                headsupTable.setValueFromCoords(columnX, y, columnValue, true);

                $($('#headsupgrid').find('td[data-x="1"][data-y="' + y + '"]')).each(function (i, obj) {
                    //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                    if (i == y) {
                        $(obj).html(columnValue);
                    }
                });

                headsupTableOnChangeDisabled = false;


            }



        },
        onselection: function (instance, x1, y1, x2, y2, origin) {

            //Used to jump to next column while marking the columnSeperator
            if (x1 == 2 || x1 == 6) {
                headsupTable.updateSelectionFromCoords(x1 + 1, y1, x2 + 1, y2);
                console.log("selected" + x1 + y1 + x2 + y2);
            }
        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
    });


    broadcastTable = jexcel(document.getElementById('broadcastgrid'), {
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        allowDeleteColumn: false,
        allowRenameColumn: false,
        columnDrag: false,
        data: null,
        tableWidth: tableWidth + 'px',
        tableHeight: tableHeight + 'px',
        minDimensions: [2, 100],
        wordWrap: true,
        search: false,
        tableOverflow: true,
        columns: [
            {
                title: residentTerm + ' Unit',
                type: 'dropdown',
                source: receiverUnits,
                width: '250px',
            },
            {
                title: residentTerm + ' Name',
                type: 'text',
                width: '200px',
                readOnly: true
            },
            {
                title: '',
                type: 'text',
                width: '2px',
            },
            {
                title: 'Exclude',
                type: 'dropdown',
                source: ['Texts', 'Emails', 'Both'],
                width: '150px',
                multiple: false,
                wordWrap: true
            },
        ],
        rowResize: true,
        onload: function (instance) {
            //Seperator colors

            $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                $(obj).css("background-color", "#ccc");
            });

            //$($(instance).find('td[data-x="6"]')).each(function (i, obj) {
            //    $(obj).css("background-color", "#ccc");
            //});

            $($(instance).find('td[data-x="0"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            //$($(instance).find('.jexcel_filter')).each(function (i, obj) {
            //    $(obj).prepend($("#people-eventlist-header-checkin-title"));
            //});

            //$(".jexcel_search").css({ "border": "1px solid #ccc" });

        },
        onchange: function (obj, cel, val) {
            // Used to avoid onchange event to propagate
            if (broadcastTableOnChangeDisabled) {
                return;
            }

            var checkinId = 0;
            var newValue = "";
            var columnToUpdate = "";



            //Grid coordinates of data just updated
            var x = parseInt($(cel).attr("data-x"));
            var y = parseInt($(cel).attr("data-y"));

            //We changed something in the first row / check in row

            //Check if the column we changed belongs to the Receiver data information
            if (x == 0) {
                //Get the ID of Receiver data changed

                var receiverLookedUp = null;
                //Get the string value of the data we just changed
                var dataChangedValue = broadcastTable.getRowData(y)[0];

                //Search through receivers that has a property with that data value
                for (var i = 0; i < receiversCache.length; i++) {
                    if (receiversCache[i]['receiverUnit'] == dataChangedValue) {
                        receiverLookedUp = receiversCache[i];
                    }
                }

                //If we didnt find any receiver with corresponding data, return
                if (receiverLookedUp == null) {
                    return;
                }

                lastReceiverLookedUpCache = receiverLookedUp;

                var columnX = 1;

                // Dont propagate onchange events
                broadcastTableOnChangeDisabled = true;

                // Fetch data from looked up receiver
                var columnValue = receiverLookedUp['receiverName'];

                // Set internal value
                broadcastTable.setValueFromCoords(columnX, y, columnValue, true);

                $($('#broadcastgrid').find('td[data-x="1"][data-y="' + y + '"]')).each(function (i, obj) {
                    //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                    if (i == y) {
                        $(obj).html(columnValue);
                    }
                });

                broadcastTableOnChangeDisabled = false;


            }
        },
        onselection: function (instance, x1, y1, x2, y2, origin) {
            //Used to jump to next column while marking the columnSeperator
            if (x1 == 2) {
                broadcastTable.updateSelectionFromCoords(x1 + 1, y1, x2 + 1, y2);
            }
        },
        onbeforechange: function (instance, cell, x, y, value) {

        },
    });

    return 1;
}



//function proxyPopulateTable(receivers) {

//    if (receiversTable != null) {
//        console.log("json parse time 1");
//        console.log((new Date()).toISOString());
//        const data = BINDING.conv_string(receivers);
//        window.receiversTable.setData(JSON.parse(data), false);
//        console.log("json parse time 2");
//        console.log((new Date()).toISOString());
//    } else {
//    }
//}
//function proxyPopulateAutoAdmitOverviewTable(overviewData) {

//    if (receiversTable != null) {
//        console.log("json parse time");
//        console.log(new Date());
//        const data = BINDING.conv_string(overviewData);
//        autoAdmitOverviewTable.setData(JSON.parse(data), false);
//        console.log(new Date());
//    } else {
//    }
//}

//Tab 1
//function PopulateReceiverTable(receiversInDatabase) {
//    var receivers = [];

//    console.log("receiversInDatabase");
//    console.log(receiversInDatabase);


//    console.log("date1");
//    console.log(new Date());
//    console.log("date2");
//    try {
//        receiversInDatabase.forEach(function (receiver) {
//            receivers.push([
//                receiver.receiverId,
//                'false',
//                receiver.receiverUnit,
//                receiver.receiverName,
//                '',
//                receiver.receiverPhonenumber,
//                receiver.receiverPhonenumberTwo,
//                receiver.receiverEmail,
//                receiver.receiverComment,
//                receiver.receiverRequireCall,
//                notificationByOptionsFromNumber(receiver.receiverNotifyBy),
//                notificationWhenOptionsFromNumber(receiver.receiverNotifyWhen)]);
//        });

//        var receiverCount = receivers.length;

//        if (receiversTable != null) {
//            console.log("SET RECV DATA, count: receiverCount" + receiverCount);
//            console.log(new Date());
//            console.log("date3");
//            window.receiversTable.setData(receivers, false);
//            console.log("date4");
//            console.log(new Date());
//        } else {
//        }



//        //Make sure receiver unit for current residents are read only, do not allow editing unit
//        for (var ri = 1; ri <= receiverCount; ri++) {
//            window.receiversTable.setReadOnly('A' + ri, true);
//            window.receiversTable.setReadOnly('B' + ri, true);
//            window.receiversTable.setReadOnly('C' + ri, true);
//            //window.receiversTable.setReadOnly('D' + ri, true);
//            // window.receiversTable.setStyle('B' + ri, 'background-color', 'red');
//        }
//    } catch (e) {
//        console.log("PopulateReceiverTable Error");
//        console.log(e);
//    }

//    return 1;
//}

//Tab 3

//function PopulateAutoAdmitOverviewTable(receiversInDatabase, dateFormat) {

//    alert("abc1!!");

//    try {

//        var receivers = [];

//        alert("abc2!!");

       
//        receiversInDatabase.forEach(function (receiver) {

//            var unitArgument = "" + receiver.receiverId + ",'" + receiver.receiverUnit + "','" + receiver.receiverName + "'";
//            var showVehicleAutoAdmitsBtn = '<div class="btn btn-primary show-autoadmits-in-grid-btn" onclick="ShowAutoAdmitDetails(1,' + unitArgument + ')" style="background-color:#fff;border-radius:2px;color:#1b6ec2;width:64px;">Manage</div>';

//            var showAutoAdmitsBtn = '<div class="btn btn-primary show-autoadmits-in-grid-btn" onclick="ShowAutoAdmitDetails(0,' + unitArgument + ')" style="background-color:#fff;border-radius:2px;color:#1b6ec2;width:64px;">Manage</div>';

//            var showPropertyAutoAdmitsBtn = '<div class="btn btn-primary show-autoadmits-in-grid-btn" onclick="ShowAutoAdmitDetails(2,' + unitArgument + ')" style="background-color:#fff;border-radius:2px;color:#1b6ec2;width:64px;">Manage</div>';

//            var autoAdmitVisitorTotalCount = 0;
//            var autoAdmitVisitorCount = 0;
//            var autoAdmitVendorCount = 0;

//            var autoAdmitVisitorCount = 0;
//            var autoAdmitVendorCount = 0;

//            var lastUpdated = null;

//            try {
//                var autoAdmitForReceiver = JSON.parse(receiver.receiverAllowList);
              
//                autoAdmitVisitorTotalCount = autoAdmitForReceiver.length;
//                for (var i = 0; i < autoAdmitVisitorTotalCount; i++) {
//                    if (autoAdmitForReceiver[i].AutoAdmitIsVendor) {
//                        autoAdmitVendorCount++;
//                    }
//                    else {
//                        autoAdmitVisitorCount++;
//                    }

//                    try {
                       

//                        var lastUpdateTemp = new Date(autoAdmitForReceiver[i].AutoAdmitUpdated);
                    

//                        if (lastUpdated == null) {
//                            lastUpdated = lastUpdateTemp;
//                        } else {
//                            if (lastUpdateTemp > lastUpdated) {
//                                lastUpdated = lastUpdateTemp;
//                            }
//                        }
//                    } catch (e) {

//                    }


//                }

               


//            }
//            catch {

//            }

//            var lastUpdatedFormatted = '';
//            if (lastUpdated != null) {
//                if (dateFormat == 0) {
//                    lastUpdatedFormatted = timestampToJexcelDate(lastUpdated);
//                }
//                else {
//                    lastUpdatedFormatted = timestampToUsDate(lastUpdated);
//                }
//            }

//            receivers.push([
//                receiver.receiverUnit,
//                receiver.receiverName,
//                '',
//                '',
//                '',
//                showAutoAdmitsBtn,
//                showVehicleAutoAdmitsBtn,
//                showPropertyAutoAdmitsBtn]);
//        });

//        var receiverCount = receivers.length;

//        if (autoAdmitOverviewTable != null) {
//            autoAdmitOverviewTable.setData(receivers, false);
//        } else {
//        }

//        //Make sure receiver unit for current residents are read only, do not allow editing unit
//        console.log("autoadmitoverview receiverCount:" + receiverCount);
//        for (var ri = 1; ri <= receiverCount; ri++) {
//            autoAdmitOverviewTable.setReadOnly('A' + ri, true);
//            // window.receiversTable.setStyle('B' + ri, 'background-color', 'red');
//        }
//    } catch (e) {
//        console.log("PopulateAutoAdmitOverviewTable Error");
//        console.log(e);
//    }


//    return 1;

//}

function PopulateAutoAdmitTable(admitType, receiversInDatabase, dateFormat) {

    try {

        var col4Title = "Driver License #";
        var col7Title = "Representative";
        var col8Title = "Relationship to Resident";


        if (admitType == 1) {
            var col4Title = "License #";
            var col7Title = "Representative";
            var col8Title = "Relation";
        }

        if (admitType == 2) {
            var col4Title = "License #";
            var col7Title = "Key";
            var col8Title = "PIN";
        }

        autoAdmitTable.setHeader(4, col4Title);
        autoAdmitTable.setHeader(7, col7Title);
        autoAdmitTable.setHeader(8, col8Title);

        autoAdmitFromPortalTable.setHeader(4, col4Title);
        autoAdmitFromPortalTable.setHeader(7, col7Title);
        autoAdmitFromPortalTable.setHeader(8, col8Title);





    } catch (e) {
        console.log(e);
    }

    try {
        var autoAdmitsStrings = [];
        var autoAdmits = [];
        var autoAdmitsFromPortal = [];

        receiversInDatabase.forEach(receiver => autoAdmitsStrings.push(receiver.receiverAllowList));

        var gatehouseGridRowCounter = 0;
        var portalGridRowCounter = 0;

        var receiverCount = receiversInDatabase.length;
        
        for (var k = 0; k < receiverCount; k++) {
            if (autoAdmitsStrings[k] != null && autoAdmitsStrings[k] != "") {
                var autoAdmitForReceiver = JSON.parse(autoAdmitsStrings[k]);
                for (var kx = 0; kx < autoAdmitForReceiver.length; kx++) {

                    
                    var line = autoAdmitForReceiver[kx];

                    var updatedString = line.autoAdmitCreatedFormatted;
                    if (dateFormat == 0) {            
                        updatedString = line.autoAdmitCreatedFormattedIso;
                    }

                    var currentRowNumber = 0;

                    var gridIndex = 0;
                    if (line.autoAdmitAddedByReceiver == true) {
                        gridIndex = 1;
                        currentRowNumber = portalGridRowCounter;
                    }
                    else {
                        currentRowNumber = gatehouseGridRowCounter;
                    }

                

                    var createPassGridButton = '<div class="create-pass-in-grid-btn" onclick="GenerateAutoAdmitPass(' + line.autoAdmitId + ',' + currentRowNumber + ',' + gridIndex + ')" style="background-color:#1b6ec2;border-radius:2px;color:#fff;font-size:80%;">Create</div>';
                    var assignTransponderAutoAdmit = '<div class="create-pass-in-grid-btn" onclick="AssignTransponderAutoAdmit(' + line.autoAdmitId + ',' + currentRowNumber + ',' + gridIndex + ')" style="background-color:#1E88E5;border-radius:2px;color:#fff;font-size:80%;">Transponder</div>';
                    var EntrancesAutoAdmitGridButton = '<div class="remove-autoadmit-in-grid-btn" onclick="OpenAutoAdmitEntrances(' + line.autoAdmitId + ',' + currentRowNumber + ',' + gridIndex + ')" style="background-color:#1E88E5;border-radius:2px;color:#fff;font-size:80%;">Entrances</div>';
                    //var ScheduleAutoAdmitGridButton = '<div class="remove-autoadmit-in-grid-btn" onclick="OpenAutoAdmitSchedule(' + line.autoAdmitId + ',' + currentRowNumber + ',' + gridIndex + ')" style="background-color:#00EB62;border-radius:2px;color:#fff;font-size:80%;">Schedule</div>';
                    var RemoveAutoAdmitGridButton = '<div class="remove-autoadmit-in-grid-btn" onclick="RemoveAutoAdmit(' + line.autoAdmitId + ',' + currentRowNumber + ',' + gridIndex + ')" style="background-color:#FF9800;border-radius:2px;color:#fff;font-size:80%;">Remove</div>';    
                    var extraAutoAdmit = '<div class="create-pass-in-grid-btn" onclick="ExtraAutoAdmit(' + line.autoAdmitId + ',' + currentRowNumber + ',' + gridIndex + ')" style="background-color:#1E88E5;border-radius:2px;color:#fff;font-size:80%;">Advanced</div>';

                    var category = 'Visitor';
                    if (line.autoAdmitCategory == autoAdmitVendorCategory) {
                        category = 'Vendor';
                    } else if (line.autoAdmitCategory == autoAdmitResidentCategory) {
                        category = 'Resident';
                    }

                    var col4Val = line.autoAdmitDriverLicense;
                    var col7Val = line.autoAdmitRepresentative;
                    var col8Val = line.autoAdmitReceiverRelation;

                    //if (admitType == 1) {
                    //    col4Val = line.autoAdmitDriverLicense;
                    //    col7Val = line.autoAdmitRepresentative;
                    //    col8Val = line.autoAdmitReceiverRelation;
                    //}

                    //if (admitType == 2) {
                    //    col4val = line.autoAdmitDriverLicense;
                    //    col7val = line.autoAdmitRfidTag;
                    //    col8val = line.autoAdmitBarcode;
                    //}

                    var receiverName = '';

                    try {
                        receiverName = line.receiverName;
                    }
                    catch { }

                    var screenNames = '';

                    try {
                        screenNames = line.autoAdmitScreenIdsAllowList;
                    }
                    catch { }


                    var dataObject = [line.autoAdmitId, line.autoAdmitName, line.autoAdmitPlateNumber, category, col4Val, line.autoAdmitIdentification, line.autoAdmitPhone, col7Val, col8Val,
                        receiverName,
                        screenNames,
                        line.autoAdmitRfidTagBlob,
                        line.autoAdmitDue,
                        line.autoAdmitDue == "Permanent" ? "" : timestampToJexcelDate(line.autoAdmitDueFrom),
                        line.autoAdmitDue == "Permanent" ? "" : timestampToJexcelDate(line.autoAdmitDueTo),
                        line.autoAdmitDescription, line.autoAdmitBanned, line.autoAdmitComment, updatedString, createPassGridButton, assignTransponderAutoAdmit, EntrancesAutoAdmitGridButton, extraAutoAdmit, RemoveAutoAdmitGridButton];


                    if (line.autoAdmitAddedByReceiver == true) {
                        autoAdmitsFromPortal.push(dataObject);
                    }
                    else {
                        autoAdmits.push(dataObject);
                    }


                    if (line.autoAdmitAddedByReceiver == true) {
                        portalGridRowCounter++;
                    }
                    else {
                        gatehouseGridRowCounter++;
                    }
                    


                }
            }

        }

        if (autoAdmitTable != null) {
            autoAdmitTable.setData(autoAdmits, false);
        } else {
        }

        if (autoAdmitFromPortalTable != null) {
            autoAdmitFromPortalTable.setData(autoAdmitsFromPortal, false);
        } else {
        }

    } catch (e) {
        console.log("PopulateAutoAdmitTable Error");
        console.log(e);
    }

    return 1;

}

function PopulateBroadcastAndHeadsup(receiversInDatabaseString) {

    const receiversInDatabaseConst = BINDING.conv_string(receiversInDatabaseString);

    var receiversInDatabase = JSON.parse(receiversInDatabaseConst);


    try {
        var receivers = [];

        var broadcastExempts = [];
        var headsUpsStrings = [];

        receiversInDatabase.forEach(function (receiver) {
            if (receiver.receiverBroadcastExemptSetting > 0) {
                broadcastExempts.push([
                    receiver.receiverUnit,
                    receiver.receiverName,
                    '',
                    broadcastExemptFromNumber(receiver.receiverBroadcastExemptSetting)]);
            }

        });


        receiversInDatabase.forEach(receiver => headsUpsStrings.push(receiver.receiverHeadsUpList));

        var receiverCount = receiversInDatabase.length;

        var headsUps = [];

        for (var k2 = 0; k2 < receiverCount; k2++) {
            if (headsUpsStrings[k2] != null && headsUpsStrings[k2] != "") {
                var headsUpForReceiver = JSON.parse(headsUpsStrings[k2]);
                for (var kx2 = 0; kx2 < headsUpForReceiver.length; kx2++) {

                    var line = headsUpForReceiver[kx2];

                    headsUps.push([line.ReceiverUnit, line.ReceiverName, '', timestampToJexcelDate(line.HeadsUpFrom), timestampToJexcelDate(line.HeadsUpTo),
                    line.CheckInAlert, '', line.HeadsUpNotes]);
                }
            }

        }

        if (headsupTable != null) {
            headsupTable.setData(headsUps, false);
        } else {
        }

        //-----

        if (broadcastTable != null) {
            broadcastTable.setData(broadcastExempts, false);
        } else {
        }

    } catch (e) {

        console.log("PopulateBroadcastAndHeadsup Error");
        console.log(e);

    }

    return 1;
}


function AddRow(arg) {
    var element = document.getElementById('spreadsheet');
    document.getElementById('spreadsheet').jexcel('insertRow')
}


function ReadAutoAdmitGrid(autoAdmitGridIndex) {
    var resultr = []
    var datar = [];

    if (autoAdmitGridIndex == 0) {
        datar = autoAdmitTable.getJson(false);
    }
    else {
        datar = autoAdmitFromPortalTable.getJson(false);
    }
     

    var rowCount = 100;
    if (datar != null) {
        rowCount = datar.length;
    }

    for (var i = 0; i < rowCount; i++) {
        var line = datar[i];
        if (line[1] && line[1] != "") {

            var autoAdmitId = 0;
            try {
                autoAdmitId = parseInt(line[0]);
               
            } catch (e) {

            }
            var autoAdmitName = line[1];
            try {
                autoAdmitName = autoAdmitName.trim();
            } catch (e) {

            }

            if (isNaN(autoAdmitId)) {
                autoAdmitId = 0;
            }

            var autoAdmitCategory = autoAdmitVisitorCategory;
            if (line[3] == 'Resident') {
                autoAdmitCategory = autoAdmitResidentCategory;
            }
            else if (line[3] == 'Vendor') {
                autoAdmitCategory = autoAdmitVendorCategory;
            }


            var row = {
                AutoAdmitId: autoAdmitId,
                AutoAdmitName: autoAdmitName,
                AutoAdmitPlateNumber: line[2],
                AutoAdmitCategory: autoAdmitCategory,
                AutoAdmitDriverLicense: line[4],
                AutoAdmitIdentification: line[5],
                AutoAdmitPhone: line[6],
                AutoAdmitRepresentative: String(line[7]),
                AutoAdmitReceiverRelation: String(line[8]),
                AutoAdmitDue: line[12],
                AutoAdmitDueFrom: jexcelDateTimeParse(line[13]),
                AutoAdmitDueTo: jexcelDateTimeParse(line[14]),
                AutoAdmitDescription: line[15],
                AutoAdmitBanned: line[16],
                AutoAdmitComment: line[17]
            };

            try {
                row.ReceiverName = line[9];
            }
            catch { }

            try {
                row.AutoAdmitScreenIdsAllowList = line[10];
            }
            catch { }

            try {
                row.AutoAdmitRfidTag = parseInt(line[11]);
                if (isNaN(row.AutoAdmitRfidTag)) {
                    row.AutoAdmitRfidTag = 0;
                }
            }
            catch { }

            try {
                row.AutoAdmitRfidTagBlob = line[11].toString();
            }
            catch { }

            //try {
       
               
            //    row.AutoAdmitRfidTag = parseInt(line[7]);
            //    if (isNaN(row.AutoAdmitRfidTag)) {
            //        row.AutoAdmitRfidTag = 0;
            //    }
                
            //} catch {
                
            //    }

            //try {
            //    row.AutoAdmitBarcode = parseInt(line[8]);

            //    if (isNaN(row.AutoAdmitBarcode)) {
            //        row.AutoAdmitBarcode = 0;
            //    }

            //} catch { }
            


            if (autoAdmitGridIndex == 0) {
                row.AutoAdmitAddedByReceiver = false;
            }
            else {
                row.AutoAdmitAddedByReceiver = true;
            }


            resultr.push(row);
        }
    }
    return resultr;
}

function ReadHeadsUpGrid() {
    var resultr = []
    var datar = headsupTable.getJson(false);

    var rowCount = 100;
    if (datar != null) {
        rowCount = datar.length;
    }

    for (var i = 0; i < rowCount; i++) {
        var line = datar[i];
        if (line[0] && line[0] != "") {

            var row = {
                ReceiverUnit: line[0],
                ReceiverName: line[1],
                HeadsUpFrom: jexcelDateTimeParse(line[3]),
                HeadsUpTo: jexcelDateTimeParse(line[4]),
                CheckInAlert: line[5],
                HeadsUpNotes: line[7]
            };

            resultr.push(row);
        }
    }
    return resultr;
}

function ReadBroadcastExemptListGrid() {
    var resultr = []
    var datar = broadcastTable.getJson(false);

    var rowCount = 100;
    if (datar != null) {
        rowCount = datar.length;
    }

    for (var i = 0; i < rowCount; i++) {
        var line = datar[i];
        if (line[0] && line[0] != "") {

            var row = {
                ReceiverUnit: line[0],
                ReceiverName: line[1],
                ReceiverBroadcastExemptSetting: line[3]
            };

            resultr.push(row);
        }
    }
    return resultr;
}


function SaveReceiversTable(args) {
    //var result = []
    //var data = window.receiversTable.getJson(false);
    //console.log(data);

    //var autoAdmitList = ReadAutoAdmitGrid();

    //var autoAdmitCount = 0;
    //if (autoAdmitList != null) {
    //    autoAdmitCount = autoAdmitList.length;
    //}

    //var headsUpList = ReadHeadsUpGrid();

    //var headsUpCount = 0;
    //if (headsUpList != null) {
    //    headsUpCount = headsUpList.length;
    //}


    //var broadcastExemptList = ReadBroadcastExemptListGrid();

    //var broadcastExemptListCount = 0;
    //if (broadcastExemptList != null) {
    //    broadcastExemptListCount = broadcastExemptList.length;
    //}

    //var rowCount = 100;
    //if (data != null) {
    //    rowCount = data.length;
    //}

    //for (var i = 0; i < rowCount; i++) {
    //    var line = data[i];
    //    if (line[1]=='true' && line[2] && line[2] != "") {

    //        var notifyBy = 0;

    //        if (line[10].includes("Email")) {
    //            notifyBy |= 2;
    //        }
    //        if (line[10].includes("Text")) {
    //            notifyBy |= 1;
    //        }

    //        var notifyWhen = 0;

    //        try {

    //            var notifyWhenStringArr = [];

    //            if (line[11].includes(";")) {
    //                notifyWhenStringArr = line[11].split(";");
    //            } else {
    //                notifyWhenStringArr.push(line[11]);
    //            }



    //            var notifyWhenStringComponentsLength = notifyWhenStringArr.length;
    //            for (var nx = 0; nx < notifyWhenStringComponentsLength; nx++) {

    //                // console.log("notifyWhenStringArr[nx]: " + notifyWhenStringArr[nx]);
    //                if (notifyWhenStringArr[nx] == "Visitor") {
    //                    notifyWhen |= 1;
    //                }

    //                if (notifyWhenStringArr[nx] == "Vendor") {
    //                    notifyWhen |= 2;
    //                }

    //                if (notifyWhenStringArr[nx] == "Auto-Admit visitor") {
    //                    notifyWhen |= 4;
    //                }

    //                if (notifyWhenStringArr[nx] == "Parcel") {
    //                    notifyWhen |= 8;
    //                }

    //                if (notifyWhenStringArr[nx] == "Visitor turned away") {
    //                    notifyWhen |= 16;
    //                }

    //            }

    //            //console.log("notifyWhen : " + notifyWhen);

    //        } catch (e) {

    //        }

    //        //var requireCall = 0; // line[7]
    //        //if (line[9]) {
    //        //    requireCall = 1;
    //        //}


    //        var comment = '';
    //        try {
    //            comment = line[8].toString();
    //        } catch (e) {
    //        }

    //        var unit = '';
    //        try {
    //            unit = line[2].toString();
    //        } catch (e) {

    //        }

    //        var name = '';
    //        try {
    //            name = line[3].toString();
    //        } catch (e) {

    //        }

    //        var phone1 = '';
    //        var phone2 = '';

    //        try {
    //            phone1 = line[5].toString();
    //        } catch (e) {

    //        }
    //        try {
    //            phone2 = line[6].toString();
    //        } catch (e) {

    //        }


    //        var email = '';
    //        try {
    //            email = line[7].toString();
    //        } catch (e) {

    //        }


    //        var row = {
    //            ReceiverUnit: unit,
    //            ReceiverName: name,
    //            ReceiverPhonenumber: phone1,
    //            ReceiverPhonenumberTwo: phone2,
    //            ReceiverEmail: email,
    //            ReceiverComment: comment,
    //            ReceiverRequireCall: requireCall,
    //            ReceiverNotifyBy: notifyBy,
    //            ReceiverNotifyWhen: notifyWhen,
    //            ReceiverAllowList: ''
    //        };


    //        if (autoAdmitCount > 0) {
    //            var allowList = [];

    //            var rowReceiverUnit = row.ReceiverUnit.toLowerCase();
    //            for (var j = 0; j < autoAdmitCount; j++) {
    //                try {
    //                    if (rowReceiverUnit.trimEnd() == autoAdmitList[j].ReceiverUnit.toLowerCase().trimEnd()) {
    //                        allowList.push(autoAdmitList[j]);
    //                    }
    //                } catch (e) {

    //                }
    //            }


    //            try {
    //                row.ReceiverAllowList = JSON.stringify(allowList);
    //            } catch (e) {

    //            }

    //        }
    //        else {
    //            row.ReceiverAllowList = '';
    //        }


    //        if (headsUpCount > 0) {
    //            var headsUp = [];

    //            var rowReceiverUnit = row.ReceiverUnit.toLowerCase();
             
    //            for (var j = 0; j < headsUpCount; j++) {
    //                try {
    //                    if (rowReceiverUnit.trimEnd() == headsUpList[j].ReceiverUnit.toLowerCase().trimEnd()) {
    //                        headsUp.push(headsUpList[j]);
    //                    }
    //                } catch (e) {

    //                }
    //            }
    //            try {
                  
    //                row.ReceiverHeadsUpList = JSON.stringify(headsUp);
    //            } catch (e) {

    //            }

    //        }
    //        else {
    //            row.ReceiverHeadsUpList = '';
    //        }

    //        if (broadcastExemptListCount > 0) {
    //            var broadcastExemptSetting = 0;

    //            var rowReceiverUnit = row.ReceiverUnit.toLowerCase();
    //            for (var j = 0; j < broadcastExemptListCount; j++) {
    //                try {
    //                    if (rowReceiverUnit.trimEnd() == broadcastExemptList[j].ReceiverUnit.toLowerCase().trimEnd()) {
    //                        console.log("found entry!: " + broadcastExemptList[j].ReceiverBroadcastExemptSetting);
    //                        if (broadcastExemptList[j].ReceiverBroadcastExemptSetting == "Both") {
    //                            broadcastExemptSetting = 3;
    //                        }
    //                        else if (broadcastExemptList[j].ReceiverBroadcastExemptSetting == "Emails") {
    //                            broadcastExemptSetting = 2;
    //                        }
    //                        else if (broadcastExemptList[j].ReceiverBroadcastExemptSetting == "Texts") {
    //                            broadcastExemptSetting = 1;
    //                        }
    //                    }
    //                } catch (e) {

    //                }
    //            }
    //            try {
    //                row.ReceiverBroadcastExemptSetting = broadcastExemptSetting;
    //            } catch (e) {

    //            }

    //        }
    //        else {
    //            row.ReceiverBroadcastExemptSetting = 0;
    //        }



    //        result.push(row);
    //    }
    //}

    //console.log(result);

    //return result;
}

function SaveAutoAdmitTable(args) {
    var result = []
  

    var autoAdmitList = ReadAutoAdmitGrid(0);
    var autoAdmitListFromPortal = ReadAutoAdmitGrid(1);

    autoAdmitList = autoAdmitList.concat(autoAdmitListFromPortal);

    console.log("autoAdmitList");
    console.log(autoAdmitList);

    var autoAdmitCount = 0;
    if (autoAdmitList != null) {
        autoAdmitCount = autoAdmitList.length;
        result = autoAdmitList;
    }




    console.log(result);

    return result;
}



function GetReceiversToDelete() {
    return receiversDeleted;
}

function ResetReceiversToDelete() {
    receiversDeleted = [];
    return 1;
}


function PopulateAwayLog(receiversInDatabase) {
    try {
        var awaylog = [];

        receiversInDatabase.forEach(receiver => awaylog.push([
            '',
            receiver.receiverUnit,
            receiver.receiverName,
            '',
            receiver.receiverAwayEnabled,
            receiver.receiverAwayEnabled ? timestampToJexcelDate(receiver.receiverAwayFrom) : '',
            receiver.receiverAwayEnabled ? timestampToJexcelDate(receiver.receiverAwayTo) : '',
            '',
            receiver.receiverHoldsEnabled,
            receiver.receiverHoldsEnabled ? receiver.receiverHoldsWhat : '',
            receiver.receiverHoldsEnabled ? timestampToJexcelDate(receiver.receiverHoldsFrom) : '',
            receiver.receiverHoldsEnabled ? timestampToJexcelDate(receiver.receiverHoldsTo) : '',
            receiver.receiverHoldsEnabled ? receiver.receiverHoldsOther : '',
            '',
            receiver.receiverHoldsComment]))

        var awayLogToShow = [];

        if (awayLogTable != null) {
            awayLogTable.setData(awaylog, false);
        } else {
        }
    } catch (e) {

        console.log("PopulateAwayLog Error");
        console.log(e);

    }



    return 1;
}


function SaveAwayLogTable(args) {
    var result = []
    var data = awayLogTable.getJson(false);

    var rowCount = 100;
    if (data != null) {
        rowCount = data.length;
    }

    for (var i = 0; i < rowCount; i++) {
        var line = data[i];
        if (line[1] && line[1] != "") {
            //3,4,7,8

            //Datetime columns

            //////////////////////////

            line[5] = jexcelDateTimeParse(line[5]);
            line[6] = jexcelDateTimeParse(line[6]);
            line[10] = jexcelDateTimeParse(line[10]);
            line[11] = jexcelDateTimeParse(line[11]);

            //////////////////////////

            var row = {
                ReceiverUnit: line[1],
                ReceiverName: line[2],
                ReceiverAwayEnabled: line[4],
                ReceiverAwayFrom: line[5],
                ReceiverAwayTo: line[6],
                ReceiverHoldsEnabled: line[8],
                ReceiverHoldsWhat: line[9],
                ReceiverHoldsFrom: line[10],
                ReceiverHoldsTo: line[11],
                ReceiverHoldsOther: line[12],
                ReceiverHoldsComment: line[14]
            };
            result.push(row);
        }
    }

    return result;
}


//////////////////////////

//function PopulateAwayLogFromPortal(receiversInDatabase) {
//    try {
//        var awaylog = [];

//        receiversInDatabase.forEach(awayLogEntry => awaylog.push([
//            awayLogEntry.awayLogId,
//            awayLogEntry.awayLogReceiverUnit,
//            awayLogEntry.awayLogReceiverName,
//            '',
//            awayLogEntry.awayLogIsEnabled,
//            awayLogEntry.awayLogIsEnabled ? timestampToJexcelDate(awayLogEntry.awayLogDueFrom) : '',
//            awayLogEntry.awayLogIsEnabled ? timestampToJexcelDate(awayLogEntry.awayLogDueTo) : '',
//            '',
//            awayLogEntry.awayLogHoldsEnabled,
//            awayLogEntry.awayLogHoldsEnabled ? awayLogEntry.awayLogHoldsWhat : '',
//            awayLogEntry.awayLogHoldsEnabled ? timestampToJexcelDate(awayLogEntry.awayLogHoldsFrom) : '',
//            awayLogEntry.awayLogHoldsEnabled ? timestampToJexcelDate(awayLogEntry.awayLogHoldsTo) : '',
//            awayLogEntry.awayLogHoldsEnabled ? awayLogEntry.awayLogHoldsOther : '',
//            '',
//            awayLogEntry.awayLogComment,
//            awayLogEntry.awayLogDescription]))

//        var awayLogToShow = [];

//        if (awayLogTableFromPortal != null) {
//            awayLogTableFromPortal.setData(awaylog, false);
//        } else {
//        }
//    } catch (e) {

//        console.log("PopulateAwayLogFromPortal Error");
//        console.log(e);

//    }



//    return 1;
//}


function SaveAwayLogTableFromPortal(args) {
    var result = []
    var data = awayLogTableFromPortal.getJson(false);

    var rowCount = 100;
    if (data != null) {
        rowCount = data.length;
    }

    for (var i = 0; i < rowCount; i++) {
        var line = data[i];
        if (line[1] && line[1] != "") {
            //3,4,7,8

            //Datetime columns

            //////////////////////////

            line[5] = jexcelDateTimeParse(line[5]);
            line[6] = jexcelDateTimeParse(line[6]);
            line[10] = jexcelDateTimeParse(line[10]);
            line[11] = jexcelDateTimeParse(line[11]);

            //////////////////////////

            var row = {
                AwayLogReceiverUnit: line[1],
                AwayLogReceiverName: line[2],
                AwayLogIsEnabled: line[4],
                AwayLogDueFrom: line[5],
                AwayLogDueTo: line[6],
                AwayLogHoldsEnabled: line[8],
                AwayLogHoldsWhat: line[9],
                AwayLogHoldsFrom: line[10],
                AwayLogHoldsTo: line[11],
                AwayLogHoldsOther: line[12],
                AwayLogComment: line[14],
                AwayLogDescription: line[15]
            };

            var awayLogId = 0;
            
            try {
                awayLogId = parseInt(line[0]);
            } catch (e) {

            }

            if (isNaN(awayLogId)) {
                awayLogId = 0;
            }

            row.AwayLogId = awayLogId;

            result.push(row);
        }
    }

    console.log("result");
    console.log(result)

    return result;
}

///////////////

function SaveGuardsTable(args) {
    var result = []
    var data = guardsTable.getJson(false);

    var rowCount = 100;
    if (data != null) {
        rowCount = data.length;
    }

    for (var i = 0; i < rowCount; i++) {
        var line = data[i];
        if (line[0] && line[0] != "") {
            var row = { GuardName: line[0], GuardEmail: line[1], GuardPhonenumber: line[2], GuardNumber: line[3], GuardColorShift: line[4], GuardLicensePlate: line[5] };
            result.push(row);
        }
    }
    return result;
}







function GetCheckoutMethod(arg) {
    var radios = document.getElementsByName('checkoutRadioGroup');
    var r = 1;
    for (var i = 0, length = radios.length; i < length; i++) {
        if (radios[i].checked) {
            return r;
            break;
        }
        r = r * 2;
    }
    return r;
}

function FileChosen(e) {

    try {
        var fileName = $('#inputGroupFile01').prop('files')[0].name;
        document.getElementById('chosenFileLabel').innerHTML = fileName;
    } catch (e) {

    }


}

function FileChosenPortalImage(e) {

    try {
        var fileName = $('#inputGroupFile02').prop('files')[0].name;
        document.getElementById('chosenFile2Label').innerHTML = fileName;
    } catch (e) {

    }


}
function FileChosenPortalImage2(e) {

    try {
        var fileName = $('#inputPortalImage2').prop('files')[0].name;
        document.getElementById('inputPortalImage2ChosenFile').innerHTML = fileName;
    } catch (e) {

    }


}

//Used in Admin page to upload logo image
function UploadFile(baseUrl, arg, screenid) {

    const path = 'api/Image/imageupload/';

    const url = new URL(
        path + encodeURIComponent(screenid),
        baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
    ).toString();

    var file_data = $('#inputGroupFile01').prop('files')[0];
    var form_data = new FormData();
    form_data.append('file', file_data);

    $.ajax({
        url: url,
        dataType: 'text',
        cache: false,
        contentType: false,
        processData: false,
        data: form_data,
        type: 'post',
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", 'Bearer ' + arg);
        },
        success: function () { },
        error: function () { }
    });
}

function UploadWelcomeImageFile(baseUrl, arg, screenid, imageIndex) {

    const path = 'api/Image/imageupload/welcome/';
    let imageUrl = new URL(
        path + encodeURIComponent(screenid),
        baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
    );

    let fileEl = '#inputGroupFile02';

    if (imageIndex > 0) {
        imageUrl.searchParams.set('imageIndex', imageIndex);
        fileEl = '#inputPortalImage' + imageIndex;
    }

    var file_data = $(fileEl).prop('files')[0];
    var form_data = new FormData();
    form_data.append('file', file_data);

    $.ajax({
        url: imageUrl.toString(),
        dataType: 'text',
        cache: false,
        contentType: false,
        processData: false,
        data: form_data,
        type: 'post',
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", 'Bearer ' + arg);
        },
        success: function () { },
        error: function () { }
    });
}

function myFunction() {
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
}

function showPeopleNotificationToast(message) {
    var x = document.getElementById("snackbarPeople");
    x.className = "show";
    x.innerHTML = message;
    setTimeout(function () { x.className = x.className.replace("show", ""); x.innerHTML = ""; }, 3000);
}

//function InitializeRequiredInputsMultiselect(arg) {
//    $(document).ready(function () {
//        $('#framework').multiselect({
//            nonSelectedText: 'Select Framework',
//            enableFiltering: true,
//            enableCaseInsensitiveFiltering: true,
//            buttonWidth: '400px'
//        });

//        //$('#framework_form').on('submit', function (event) {
//        //    event.preventDefault();
//        //    var form_data = $(this).serialize();
//        //    $.ajax({
//        //        url: "insert.php",
//        //        method: "POST",
//        //        data: form_data,
//        //        success: function (data) {
//        //            $('#framework option:selected').each(function () {
//        //                $(this).prop('selected', false);
//        //            });
//        //            $('#framework').multiselect('refresh');
//        //            alert(data);
//        //        }
//        //    });
//        //});


//    });


//}

function confirmPinChange(newPinToDisplay) {

    swal({
        title: "Are you sure?",
        text: "If you change the Screen Password all the monitors you have setup will need to enter the new Password.",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, change Password.",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnPinChangeConfirmed', newPinToDisplay);
            swal("Changed.", "Screen Password was changed to " + newPinToDisplay, "success");

        });
}

function showColumnHelp() {
    swal({
        title: "",
        text: " ",
        imageUrl: 'img/colhelp.png',
        customClass: 'swal-wide-column-tips',
        imageSize: '1024x400'
    });
}

function showTextServiceLicense() {

    $("#sendTextCheckIn").prop('checked', false);
    $("#sendTextCheckInParcel").prop('checked', false);

    swal({
        title: "Text provider",
        text: "\nThis option requires a Text/SMS notification license.\n\nContact us at info@visitform.com for a quote.",
    });
}

function showReceiverUnitDuplicateError() {
    swal({
        title: "Unit must be unique",
        text: "\nThe unit number must be unique. Verify there are no duplicates in the column 'Unit'\n\nChanges have not been saved",
        type: "info"
    });
}

function initSortable(arg) {
    $(document).ready(function () {

        $('#sortable-div .sortable-list').sortable({
            connectWith: '#sortable-div .sortable-list',
            placeholder: 'placeholder',
            update: function (x, y) {

                var requiredInputsInOrder1 = GetRequiredInputsConfiguration('AdminVisitor-sortable');
                var requiredInputsInOrder2 = GetRequiredInputsConfiguration('AdminVendor-sortable');
                var requiredInputsInOrder3 = GetRequiredInputsConfiguration('AdminHost-sortable');

                DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnAdminColumnOrderChange', requiredInputsInOrder1, 0);
                DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnAdminColumnOrderChange', requiredInputsInOrder2, 1);
                DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnAdminColumnOrderChange', requiredInputsInOrder3, 2);
            }
        });
    });
}

function GetRequiredInputsConfiguration(el) {

    var requiredInputArray = [];

    $('#' + el + ' .sortable-required-input').each(function (index, element) {

        var requiredInputId = $(element).attr("data-id");
        var requiredInputStatus = false;

        $(element).find('input:checkbox:first').each(function () {
            if (this.checked) {
                requiredInputStatus = true;
            }
        });

        if (requiredInputStatus) {
            requiredInputArray.push(requiredInputId);
        }

    });

    var requiredInputsInOrder = requiredInputArray.join();

    return requiredInputsInOrder;
}

function ShowAutoAdmitDetails(admitType, receiverId, unit, name) {

 
    //var rowNumber = autoAdmitOverviewTable.getSelectedRows();

    //console.log("selected rows:");
    //console.log(rowNumber);

    //var rowData = "";

    //for (var i = 1; i < 2; i++) {
    //    rowData += rowNumber[0].cells[i].innerHTML + ";";
    //}

    try {

        var col4Title = "Driver License #";
        var col7Title = "Representative";
        var col8Title = "Relationship to Resident";
        

        if (admitType == 1) {
            var col4Title = "License #";
            var col7Title = "Tag";
            var col8Title = "Barcode";
        }

        if (admitType == 2) {
            var col4Title = "License #";
            var col7Title = "Key";
            var col8Title = "PIN";
        }

        autoAdmitTable.setHeader(4, col4Title);
        autoAdmitTable.setHeader(7, col7Title);
        autoAdmitTable.setHeader(8, col8Title);

        autoAdmitFromPortalTable.setHeader(4, col4Title);
        autoAdmitFromPortalTable.setHeader(7, col7Title);
        autoAdmitFromPortalTable.setHeader(8, col8Title);


        
       

    } catch (e) {
        console.log(e);
    }

    var rowData = admitType + ";" + receiverId + ";" + unit + ";" + name + ";";
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnShowAutoAdmitDetailsList', rowData);
}

function ManageResidents(receiverId) {
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnShowResidentsDetailsList', receiverId);
}


function GenerateAutoAdmitPass(autoAdmitId, gridRowNumber, autoAdmitGridIndex) {

    try {
        var rowNumber = [];

        console.log("autoAdmitGridIndex:" + autoAdmitGridIndex);

        if (autoAdmitGridIndex == 0) {
            console.log("fetching from gatehouse table: " + gridRowNumber);
            //rowNumber = autoAdmitTable.getSelectedRows();
            rowNumber = autoAdmitTable.getRowData(gridRowNumber);
        }
        else {
            console.log("fetching from portal table: " + gridRowNumber);
            rowNumber = autoAdmitFromPortalTable.getRowData(gridRowNumber);
        }
        

        console.log("selected rows:");
        console.log(rowNumber);

        var rowData = autoAdmitId + ";";

        for (var i = 1; i < 10; i++) {
            //rowData += rowNumber[0].cells[i].innerHTML + ";";
            rowData += rowNumber[i] + ";";
        }


        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnGenerateAutoAdmitPass', rowData);

        autoAdmitTable.resetSelection();
    } catch (e) {
        console.log(e);
    }
}

function RemoveAutoAdmit(autoAdmitId, gridRowNumber, autoAdmitGridIndex) {

    try {
        var rowNumber = [];

        console.log("RemoveAutoAdmit:" + autoAdmitId);

        //if (autoAdmitGridIndex == 0) {
        //    console.log("fetching from gatehouse table: " + gridRowNumber);
        //    rowNumber = autoAdmitTable.getRowData(gridRowNumber);
        //}
        //else {
        //    console.log("fetching from portal table: " + gridRowNumber);
        //    rowNumber = autoAdmitFromPortalTable.getRowData(gridRowNumber);
        //}

 



        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartDeleteAutoAdmit', autoAdmitId.toString());


       // DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnGenerateAutoAdmitPass', rowData);

        //autoAdmitTable.resetSelection();
    } catch (e) {
        console.log(e);
    }
}

function OpenAutoAdmitSchedule(autoAdmitId, gridRowNumber, autoAdmitGridIndex) {

    try {
        var rowNumber = [];

        console.log("OpenAutoAdmitSchedule:" + autoAdmitId);

        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartOpenScheduleAutoAdmit', autoAdmitId.toString());

    } catch (e) {
        console.log(e);
    }
}

function OpenAutoAdmitEntrances(autoAdmitId, gridRowNumber, autoAdmitGridIndex) {

    try {
        var rowNumber = [];

        console.log("OpenAutoAdmitEntrances:" + autoAdmitId);

        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartOpenEntrancesAutoAdmit', autoAdmitId.toString());

        //DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartDeleteAutoAdmit', autoAdmitId.toString());

    } catch (e) {
        console.log(e);
    }
}

function AssignTransponderAutoAdmit(autoAdmitId, gridRowNumber, autoAdmitGridIndex) {

    try {
        var rowNumber = [];

        console.log("AssignTransponderAutoAdmit:" + autoAdmitId);

        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartAssignTransponderAutoAdmit', autoAdmitId.toString());

    } catch (e) {
        console.log(e);
    }
}

function ExtraAutoAdmit(autoAdmitId, gridRowNumber, autoAdmitGridIndex) {

    try {
        var rowNumber = [];

        console.log("ExtraAutoAdmit:" + autoAdmitId);

        DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnStartOpenExtraDataAutoAdmit', autoAdmitId.toString());

    } catch (e) {
        console.log(e);
    }
}

function confirmRevokePass(autoAdmitPassId) {

    swal({
        title: "Are you sure?",
        text: " ",
        showCancelButton: true,
        confirmButtonText: "Yes, revoke.",
        confirmButtonClass: "btn-warning",
        cancelButtonText: "No",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnRevokePass', autoAdmitPassId);
        });
}

function confirmEmailPass(autoAdmitPassId, blobIdentifier) {

    swal({
        title: "Send Auto-Admit pass by email",
        text: "Enter recipient email address:",
        type: "input",
        showCancelButton: true,
        confirmButtonText: "Send",
        closeOnConfirm: false,
        inputPlaceholder: "Email"
    }, function (inputValue) {
        if (inputValue === false) return false;
        if (inputValue === "") {
            swal.showInputError("Empty input");
            return false
        }

        if (validateEmail(inputValue)) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnEmailPass', autoAdmitPassId, inputValue, blobIdentifier);
            swal("Email sent", "Auto-Admit pass was sent to " + inputValue, "success");
        }
        else {
            swal.showInputError("Invalid email address");
            return false;
        }
        

       
    });
}

function setAppGuideScreenPinDisplay(pin) {
    document.getElementById('appGuideScreenPin').innerHTML = pin;
    document.getElementById('appGuideScreenPinAndroid').innerHTML = pin;
}

function appGuideNext() {
    $('#appInformationGuide').carousel('next');
    $('#appInformationGuideAndroid').carousel('next');
}

function appGuidePrev() {
    $('#appInformationGuide').carousel('prev');
    $('#appInformationGuideAndroid').carousel('prev');
}



function createIssuedPassTooltip(el, text) {


    setTimeout(function () {
        tippy(el, {
            content: '<span>' + text + '</span>',
            allowHTML: true
        });
    }, 1500);

}

//////////////////////////////////////////
var cacheAwayLogTableHeight = [256, 256];
var cacheAwayLogTableIsExpanded = [false, false];

function setAwayLogTableHeight(gridIndex) {

    if (gridIndex == 0) {

        $($('#awayloggrid').find('.jexcel_content')).each(function (i, obj) {
            if (i == 0) {
                toogleAwayLogTableHeight(obj, gridIndex);
            }
        });
    }
    else if (gridIndex == 1) {
        $($('#awayloggridportal').find('.jexcel_content')).each(function (i, obj) {
            if (i == 0) {
                toogleAwayLogTableHeight(obj, gridIndex);
            }
        });
    } 
}

function toogleAwayLogTableHeight(obj, gridIndex) {

    if (!cacheAwayLogTableIsExpanded[gridIndex]) {

        var readMaxHeight = $(obj).css('max-height');
        cacheAwayLogTableHeight[gridIndex] = parseInt(readMaxHeight);

        var newHeight = cacheAwayLogTableHeight[gridIndex] * 2;
        $(obj).css({ "maxHeight": newHeight + "px" });

        cacheAwayLogTableIsExpanded[gridIndex] = true;
    }
    else {

        var newHeight = cacheAwayLogTableHeight[gridIndex]
        $(obj).css({ "maxHeight": newHeight + "px" });

        cacheAwayLogTableIsExpanded[gridIndex] = false;
    }

}
//////////////////////////////////////////
//////////////////////////////////////////

var cacheAutoAdmitDetailsTableHeight = [256, 256];
var cacheAutoAdmitDetailsTableIsExpanded = [false, false];

function setAutoAdmitDetailsTableHeight(gridIndex) {

    if (gridIndex == 0) {

        $($('#autoadmitgrid').find('.jexcel_content')).each(function (i, obj) {
            if (i == 0) {
                toogleAutoAdmitDetailsTableHeight(obj, gridIndex);
            }
        });
    }
    else if (gridIndex == 1) {
        $($('#autoadmitgridfromportal').find('.jexcel_content')).each(function (i, obj) {
            if (i == 0) {
                toogleAutoAdmitDetailsTableHeight(obj, gridIndex);
            }
        });
    }
}

function toogleAutoAdmitDetailsTableHeight(obj, gridIndex) {

    if (!cacheAutoAdmitDetailsTableIsExpanded[gridIndex]) {

        var readMaxHeight = $(obj).css('max-height');
        cacheAutoAdmitDetailsTableHeight[gridIndex] = parseInt(readMaxHeight);

        var newHeight = cacheAutoAdmitDetailsTableHeight[gridIndex] * 2;
        $(obj).css({ "maxHeight": newHeight + "px" });

        cacheAutoAdmitDetailsTableIsExpanded[gridIndex] = true;
    }
    else {

        var newHeight = cacheAutoAdmitDetailsTableHeight[gridIndex]
        $(obj).css({ "maxHeight": newHeight + "px" });

        cacheAutoAdmitDetailsTableIsExpanded[gridIndex] = false;
    }

}
//////////////////////////////////////////

function capitalizeFirstLetterPeoplesPage(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


async function triggerGetListTableDataFromListPage(handler) {
    handler.invokeMethodAsync("FetchTableDataFromListPage").then((value) => {
        if (receiversTable != null) {
            window.receiversTable.setData(value, false);
        } 

    });
}

async function triggerGetListTableDataOverviewFromListPage(handler) {
    handler.invokeMethodAsync("FetchTableDataOverviewFromListPage").then((value) => {
        if (receiversTable != null) {
            autoAdmitOverviewTable.setData(value, false);
        }

    });
}

var receiversCache = [];

function setReceiversCacheFromComponentUnmarshalled(cacheString) {
    const receiversConst = BINDING.conv_string(cacheString);
    receiversCache = JSON.parse(receiversConst);
}